
const APP_NAME = 'PolkaBTC';

const ACCOUNT_ID_TYPE_NAME = 'AccountId';

export {
  APP_NAME,
  ACCOUNT_ID_TYPE_NAME
};
